import * as React from "react";
import {cx} from "emotion";

import "./step-2-build.scss";

import {cs}          from "@Common/react/chain-services";
import {scopedState} from "@Common/react/scoped-state";
import {UseState}    from "@Common/react/use-state";

import {Header} from "../../common/header/header";

import {SectionMapping}           from "./section-mapping/section-mapping";
import {SectionPreview}           from "./section-preview/section-preview";
import {SectionRequestAssistance} from "./section-request-assistance/section-request-assistance";

export const Step2Build = ({fileName, countryCode, columns, rows, filePath, itemId, getInitData, onNext, onClose, onBack}) => cs(
    ["data", (_, next) => UseState({
        getInitValue: getInitData,
        next,
    })],
    ["sectionMapping", ({data}, next) => SectionMapping({
        fileName,
        columns,
        rows,
        keys: scopedState(data, ["keys"]),
        countryCode,
        next,
    })],
    ["sections", ({sectionMapping}, next) => next([
        sectionMapping,
    ])],
    ["showErrors", (_, next) => UseState({next})],
    ({data, sectionMapping, sections, showErrors}) => (
        <div className="step-2-build-9t7">
            {Header({
                icon: require("../../../../mailing-icons/listtype-upload.png"),
                title: "Build Address List",
                subTitle: "Upload, manage, and store your existing mailing list.",
            })}

            <div className="content">
                {sectionMapping.render({showErrors: showErrors.value})}

                {itemId != null && (
                    SectionRequestAssistance({
                        onClose,
                        itemId,
                        filePath,
                    })
                )}

                {SectionPreview({
                    rows,
                    keys: data.value.keys,
                    modification: scopedState(data, ["modification"]),
                    countryCode,
                    onClose,
                })}

            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: onBack,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Build Address List Back",
                }}>
                    Back
                </button>

                <button {...{
                    className: cx("next", {disabled: sections.find((section) => section.invalid)}),
                    onClick: async () => {
                        if (sections.find((section) => section.invalid)) {
                            showErrors.onChange(true);
                            sections.find((section) => section.invalid && section.highlightErrors)?.highlightErrors();
                        } else {
                            onNext(data.value);
                        }
                    },
                    "xd-qa-type": "button",
                    "xd-qa-name": "Build Address List Next",
                }}>
                    Next
                </button>
            </div>
        </div>
    ),
);
